import React from "react";
import axios from "axios";

const API_BASE = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");

export default function useHriBenefits({ includeInactive = true } = {}) {
    const [benefits, setBenefits] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState("");

    const fetchBenefits = React.useCallback(async () => {
        setLoading(true);
        setError("");
        try {
            const res = await axios.get(`${API_BASE}/api/hri-benefits`, {
                params: { include_inactive: includeInactive },
                withCredentials: true,
            });
            setBenefits(Array.isArray(res.data) ? res.data : []);
        } catch (e) {
            setError(e?.response?.data?.error || e.message || "HRI Vorteile konnten nicht geladen werden.");
        } finally {
            setLoading(false);
        }
    }, [includeInactive]);

    React.useEffect(() => {
        fetchBenefits();
    }, [fetchBenefits]);

    const createBenefit = async (payload) => {
        const res = await axios.post(`${API_BASE}/api/hri-benefits`, payload, { withCredentials: true });
        await fetchBenefits();
        return res.data;
    };

    const updateBenefit = async (id, payload) => {
        const res = await axios.put(`${API_BASE}/api/hri-benefits/${id}`, payload, { withCredentials: true });
        await fetchBenefits();
        return res.data;
    };

    const deleteBenefit = async (id) => {
        const res = await axios.delete(`${API_BASE}/api/hri-benefits/${id}`, { withCredentials: true });
        await fetchBenefits();
        return res.data;
    };

    return { benefits, loading, error, fetchBenefits, createBenefit, updateBenefit, deleteBenefit };
}
